import { isWeb, getPlatform } from '../src/utils/platformUtils'
import { SCHEDULES_STORE_NAMES } from '../src/db/constants'
import { FORM_SCHEDULE_STATUS, STATUS_FORM_PENDING_SYNC } from '../src/components/stores/constants/constants.stores'
import { LEARNING_STORE_NAMES } from './learning.database'
import { BENEFITS_STORE_NAMES } from '../src/db/constants'
import { POST_TABLE_NAMES } from '../src/db/constants'
import { TRACKINGS } from './tracking.database'
import { PORTFOLIO_STORE_NAMES } from '../src/db/constants'
import { openDB } from '../src/db/indexDB'

const FOOTER_APP = 'footer_app'
const USER_PROFILE = 'user_profiles'
const postsStoreName = 'posts'
const REACTIONS = 'reactions'
let __dbModule = null
let __userRepositoryModule = null // ✅ Cache para el módulo user.repository

const buildLocalWrappedDb = () => {
    if (globalThis.__DOTS_SQLITE_WRAPPED_DB) {
        return globalThis.__DOTS_SQLITE_WRAPPED_DB
    }
    try {
        const localDb = require('expo-sqlite').openDatabaseSync('myDB')
        if (getPlatform().OS === 'android') {
            try {
                localDb.execSync('PRAGMA journal_mode = WAL;')
            } catch {}
        }
        try {
            localDb.execSync('PRAGMA busy_timeout = 3000;')
        } catch {}
        const wrapStatement = (stmt) => ({
            executeSync: (params = []) => {
                const res = stmt.executeSync(params)
                const rowsArray = Array.isArray(res?.rows) ? res.rows : Array.isArray(res?.rows?._array) ? res.rows._array : []
                return {
                    ...res,
                    getAllSync: () => rowsArray,
                    getFirstSync: () => (rowsArray && rowsArray.length ? rowsArray[0] : null),
                }
            },
            finalizeSync: () => stmt.finalizeSync(),
        })
        const wrapped = {
            execSync: (sql) => localDb.execSync(sql),
            prepareSync: (sql) => {
                const stmt = localDb.prepareSync(sql)
                const wrapped = wrapStatement(stmt)
                return {
                    executeSync: wrapped.executeSync,
                    finalizeSync: wrapped.finalizeSync,
                    getAllSync: (params = []) => wrapped.executeSync(params).getAllSync(),
                    getFirstSync: (params = []) => wrapped.executeSync(params).getFirstSync(),
                }
            },
        }
        globalThis.__DOTS_SQLITE_WRAPPED_DB = wrapped
        return wrapped
    } catch (e) {
        console.error('Fallback SQLite wrapper build failed:', e)
        return null
    }
}
const getWrappedDB = () => {
    if (!__dbModule) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        __dbModule = require('../src/db/indexDB')
    }
    const fromIndex = __dbModule?.getNativeDB ? __dbModule.getNativeDB() : null
    return fromIndex || buildLocalWrappedDb()
}

const versionsStoreName = 'versions'

const openDatabase = () => {
    if (isWeb()) {
        return {
            transaction: () => ({ executeSql: () => {} }),
        }
    }

    const dbSync = getWrappedDB()
    const facade = {
        execSync: (sql) => dbSync.execSync(sql),
        prepareSync: (sql) => dbSync.prepareSync(sql),
        transaction: (callback, errorCallback, successCallback) => {
            try {
                const tx = {
                    executeSql: (sql, params = [], success, error) => {
                        try {
                            const isSelect = /^\s*SELECT/i.test(sql)
                            if (isSelect) {
                                const stmt = dbSync.prepareSync(sql)
                                const rowsArray = stmt.getAllSync(params)
                                stmt.finalizeSync()
                                const rows = {
                                    length: rowsArray.length,
                                    item: (i) => rowsArray[i],
                                    _array: rowsArray,
                                }
                                const result = { rows, rowsAffected: 0, insertId: undefined }
                                success && success(tx, result)
                            } else {
                                const stmt = dbSync.prepareSync(sql)
                                stmt.executeSync(params)
                                stmt.finalizeSync()
                                const changes = dbSync.prepareSync('SELECT changes() as rowsAffected').getFirstSync()
                                const lastId = /\bINSERT\b/i.test(sql)
                                    ? dbSync.prepareSync('SELECT last_insert_rowid() as insertId').getFirstSync()
                                    : { insertId: undefined }
                                const result = {
                                    rows: { length: 0, item: () => undefined, _array: [] },
                                    rowsAffected: changes?.rowsAffected ?? 0,
                                    insertId: lastId?.insertId,
                                }
                                success && success(tx, result)
                            }
                        } catch (e) {
                            if (error) return error(tx, e)
                            throw e
                        }
                    },
                }
                callback && callback(tx)
                successCallback && successCallback()
            } catch (e) {
                errorCallback && errorCallback(e)
            }
        },
    }
    return facade
}

export const db = openDatabase()

class userServices {
    constructor() {
        this.db = db
    }

    /**
     * @description updatea la tabla footer por lo que recibe por param
     * @param {*} newData single.data.footer_app
     * @returns
     */
    updateFooter = (newData) => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                console.log('[updateFooter][web] 🔧 VERSION 6: Using operation counter instead of tx.oncomplete')

                // Import and open DB
                import('../src/db/indexDB')
                    .then(({ openDB }) => openDB())
                    .then((indexedDB) => {
                        console.log('[updateFooter][web] 📂 Database opened, creating transaction...')

                        const tx = indexedDB.transaction([FOOTER_APP], 'readwrite')
                        const store = tx.objectStore(FOOTER_APP)

                        // ❌ tx.oncomplete NO FUNCIONA - usando contador manual
                        let completedOps = 0
                        const totalOps = 1 + newData.length // clear + puts

                        const checkComplete = () => {
                            completedOps++
                            console.log(`[updateFooter][web] 📊 Progress: ${completedOps}/${totalOps}`)
                            if (completedOps === totalOps) {
                                console.log('[updateFooter][web] ✅ All operations completed!')
                                // Dar un tick para que la transacción termine
                                setTimeout(() => resolve(), 0)
                            }
                        }

                        tx.onerror = (e) => {
                            console.error('[updateFooter][web] ❌ Transaction error:', e.target.error)
                            reject(e.target.error)
                        }

                        tx.onabort = (e) => {
                            console.error('[updateFooter][web] ❌ Transaction aborted')
                            reject(new Error('Transaction aborted'))
                        }

                        console.log('[updateFooter][web] 🗑️ Clearing store...')
                        const clearReq = store.clear()
                        clearReq.onsuccess = () => {
                            console.log('[updateFooter][web] ✓ Store cleared successfully')
                            checkComplete()
                        }
                        clearReq.onerror = (e) => {
                            console.error('[updateFooter][web] ❌ Clear failed:', e.target.error)
                            reject(e.target.error)
                        }

                        console.log('[updateFooter][web] 📝 Inserting', newData.length, 'items...')
                        newData.forEach(({ _id, label, icon, nav = false, section = false }, idx) => {
                            const putReq = store.put({ _id, label, icon, nav, section })
                            putReq.onsuccess = () => {
                                if (idx === 0) {
                                    console.log('[updateFooter][web] ✓ First item inserted:', label)
                                }
                                if (idx === newData.length - 1) {
                                    console.log('[updateFooter][web] ✓ Last item inserted:', label)
                                }
                                checkComplete()
                            }
                            putReq.onerror = (e) => {
                                console.error('[updateFooter][web] ❌ Put failed for', label, ':', e.target.error)
                                reject(e.target.error)
                            }
                        })

                        console.log('[updateFooter][web] ⏳ All operations queued, waiting for completion...')
                    })
                    .catch((err) => {
                        console.error('[updateFooter][web] ❌ Exception during setup:', err)
                        reject(err)
                    })
            } else {
                db.transaction(
                    (tx) => {
                        // Borra todos los datos existentes en la tabla
                        tx.executeSql(`DELETE FROM ${FOOTER_APP};`)
                        // Inserta los nuevos datos
                        newData.forEach(({ _id, label, icon, nav = false, section = false }) => {
                            tx.executeSql(
                                `INSERT INTO ${FOOTER_APP} (_id, label, icon , nav, section, name) VALUES (?, ?, ? ,?, ?,?);`,
                                [_id, label, icon, nav, section],
                                (_, result) => {
                                    // console.log(`Datos insertados en ${FOOTER_APP} correctamente.`);
                                },
                                (_, error) => {
                                    console.error(`Error al insertar datos en ${FOOTER_APP}:`, error)
                                },
                            )
                        })
                    },
                    null,
                    () => {
                        // console.log('Tabla actualizada exitosamente.');
                        resolve()
                    },
                    (error) => {
                        console.error('Error al actualizar el footer:', error)
                        reject(error)
                    },
                )
            }
        })
    }

    getFooterApp = () => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                try {
                    const { openDB } = await import('../src/db/indexDB')
                    const indexedDB = await openDB()
                    const transaction = indexedDB.transaction([FOOTER_APP], 'readonly')
                    const objectStore = transaction.objectStore(FOOTER_APP)
                    const request = objectStore.getAll()

                    request.onsuccess = (event) => {
                        const items = event.target.result
                        if (Array.isArray(items) && items.length > 0) {
                            console.log(
                                '[user.database][getFooterApp][web] Items IndexedDB:',
                                items.map((i) => i.label),
                            )
                            resolve(items)
                        } else {
                            console.warn('[user.database][getFooterApp][web] footer_app vacío. Retornando [] sin fallback.')
                            resolve([])
                        }
                    }

                    request.onerror = (event) => {
                        console.error('[user.database][getFooterApp][web] IndexedDB error:', event.target.error)
                        resolve([])
                    }
                } catch (error) {
                    console.error('[user.database][getFooterApp][web] Exception:', error)
                    resolve([])
                }
            } else {
                // Código para obtener versión global de expo-sqlite
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `SELECT * FROM ${FOOTER_APP};`,
                            [],
                            (_, result) => {
                                const footer_app = result.rows._array
                                // console.log('1268 🚀 ~ returnnewPromise ~ footer_app:', footer_app)
                                resolve(footer_app)
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite FOOTER_APP  error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }

    getNavApp = () => {
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                try {
                    const { openDB } = await import('../src/db/indexDB')
                    const indexedDB = await openDB()
                    const transaction = indexedDB.transaction(['nav_app'], 'readonly')
                    const objectStore = transaction.objectStore('nav_app')
                    const request = objectStore.getAll()

                    request.onsuccess = (event) => {
                        const version = event.target.result
                        resolve(version ? version.value : null)
                    }

                    request.onerror = (event) => {
                        reject(event.target.error)
                    }
                } catch (error) {
                    console.error('Error accessing IndexedDB in getNavApp:', error)
                    resolve(null)
                }
            } else {
                // Código para obtener versión global de expo-sqlite
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `SELECT * FROM ${FOOTER_APP} WHERE nav = 1;`,
                            [],
                            (_, result) => {
                                const footer_app = result.rows._array
                                // console.log('1268 🚀 ~ returnnewPromise ~ footer_app:', footer_app)
                                resolve(footer_app)
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite FOOTER_APP  error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }
    getSectionApp = () => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                const transaction = db.transaction([FOOTER_APP], 'readonly')
                const objectStore = transaction.objectStore(FOOTER_APP)
                const request = objectStore.getAll()

                request.onsuccess = (event) => {
                    const version = event.target.result
                    resolve(version ? version.value : null)
                }

                request.onerror = (event) => {
                    reject(event.target.error)
                }
            } else {
                // Código para obtener versión global de expo-sqlite
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `SELECT * FROM ${FOOTER_APP} WHERE section = 1;`,
                            [],
                            (_, result) => {
                                const footer_app = result.rows._array
                                resolve(footer_app)
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        reject(error)
                    },
                    null,
                )
            }
        })
    }
    getGlobalVersion = (serviceName) => {
        //console.log('entro aaaa getversion')
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                try {
                    const database = await openDB()
                    const transaction = database.transaction([versionsStoreName], 'readonly')
                    const objectStore = transaction.objectStore(versionsStoreName)
                    const request = objectStore.get(serviceName)

                    request.onsuccess = (event) => {
                        const version = event.target.result
                        resolve(version ? version.value : null)
                    }

                    request.onerror = (event) => {
                        reject(event.target.error)
                    }
                } catch (error) {
                    console.error('Error accessing IndexedDB in getGlobalVersion:', error)
                    resolve(null)
                }
            } else {
                // Código para obtener versión global de expo-sqlite
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `SELECT value FROM ${versionsStoreName} WHERE serviceName = ?;`,
                            [serviceName],
                            (_, result) => {
                                //   console.log('SQLite result get  version:', result)
                                const version = result.rows.item(0)
                                resolve(version ? version.value : null)
                            },
                            (_, error) => {
                                console.error('Error en la transacción GET GLOBAL VERSION:', error)
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite getGlobalVersion  error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }

    updateGlobalVersion = (serviceName, new_version) => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                const transaction = db.transaction([versionsStoreName], 'readwrite')
                const objectStore = transaction.objectStore(versionsStoreName)

                // Obtener el valor existente
                const getRequest = objectStore.get(serviceName)

                getRequest.onsuccess = (event) => {
                    const existingVersion = event.target.result ? event.target.result.value : null

                    // Verificar si el valor existe y es diferente o si es nulo (no existe)
                    if (existingVersion !== new_version || existingVersion === null) {
                        // Actualizar el valor
                        const putRequest = objectStore.put({ serviceName, value: new_version })

                        putRequest.onsuccess = () => {
                            resolve()
                        }

                        putRequest.onerror = (event) => {
                            reject(event.target.error)
                        }
                    } else {
                        // No es necesario actualizar, el valor ya es el mismo
                        resolve()
                    }
                }

                getRequest.onerror = (event) => {
                    reject(event.target.error)
                }
            } else {
                // Código para actualizar versión global de expo-sqlite
                // console.log('estoy en updateGlobalVersion ');
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `INSERT OR REPLACE INTO ${versionsStoreName} VALUES (?, ?);`,
                            [serviceName, new_version],
                            (_, result) => {
                                resolve()
                            },
                            (_, error) => {
                                console.log('00 Error updating global version:', serviceName)
                                console.error('01 Error updating global version:', error)
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('Transaction error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }

    getUser = () => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                const transaction = db.transaction([USER_PROFILE], 'readonly')
                const objectStore = transaction.objectStore(USER_PROFILE)
                const request = objectStore.getAll()

                request.onsuccess = (event) => {
                    const version = event.target.result
                    resolve(version ? version.value : null)
                }

                request.onerror = (event) => {
                    reject(event.target.error)
                }
            } else {
                // Código para obtener versión global de expo-sqlite
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `SELECT * FROM ${USER_PROFILE};`,
                            [],
                            (_, result) => {
                                //   console.log('🚀 ~  USER returnnewPromise ~ result:', result)
                                // console.log("SQLite result:", result);
                                let user = result.rows.item(0)
                                if (user) {
                                    user = { ...user, user_segment: JSON.parse(user.user_segment) }
                                    // user.user_segment = JSON.parse(user.user_segment)
                                }
                                //~  USER returnnewPromise   console.log('🚀 ~ returnnewPromise ~ user:', user)
                                resolve(user)
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite USER  error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }
    // updates = { name: "Doh" }
    updateUser = (user_id, updates) => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                reject(new Error('Esta función no es compatible con la plataforma web'))
            } else {
                // Construir dinámicamente la consulta SQL y los parámetros
                const keys = Object.keys(updates) // Extraer las claves del objeto `updates`
                const values = Object.values(updates) // Extraer los valores del objeto `updates`

                // Crear la parte SET de la consulta SQL
                const setClause = keys.map((key) => `${key} = ?`).join(', ')

                // Agregar el `user_id` al final de los valores
                values.push(user_id)

                const query = `UPDATE ${USER_PROFILE} SET ${setClause} WHERE _id = ?;`

                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            query,
                            values,
                            (_, result) => {
                                resolve(result)
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite USER error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }
    getTableNames = () => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
            } else {
                // Código para obtener nombres de tablas con expo-sqlite
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            `SELECT name FROM sqlite_master WHERE type='table';`,
                            [],
                            (_, result) => {
                                const tableNames = []
                                for (let i = 0; i < result.rows.length; i++) {
                                    tableNames.push(result.rows.item(i).name)
                                }
                                resolve(tableNames) // Devuelve la lista de nombres de tablas
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }

    // getTableData = (tableName, page = 1, pageSize = 100, search) => {
    //     return new Promise((resolve, reject) => {
    //         if (isWeb()) {
    //         } else {
    //             const offset = (page - 1) * pageSize
    //             // Código para obtener los datos de una tabla en expo-sqlite
    //             db.transaction(
    //                 (tx) => {
    //                     tx.executeSql(
    //                         `SELECT * FROM ${tableName} ORDER BY ROWID ASC LIMIT ? OFFSET ?;`,
    //                         //`SELECT * FROM ${tableName};`,
    //                         [pageSize, offset],
    //                         (_, result) => {
    //                             //console.log("🚀 ~ userServices ~ returnnewPromise ~ result:", result)
    //                             resolve(result.rows._array) // Devuelve las filas de la tabla
    //                         },
    //                         (_, error) => {
    //                             reject(error)
    //                         },
    //                     )
    //                 },
    //                 (error) => {
    //                     console.error('SQLite error:', error)
    //                     reject(error)
    //                 },
    //                 null,
    //             )
    //         }
    //     })
    // }
    getTableData = (tableName, page = 1, pageSize = 100, search = '') => {
        console.log('🚀 ~ userServices ~ search:', search)
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                // Manejar la lógica para web si es necesario
            } else {
                const offset = (page - 1) * pageSize
                let query = `SELECT * FROM ${tableName}`
                let params = [pageSize, offset]

                // Si hay búsqueda, construimos la condición WHERE
                if (search) {
                    try {
                        const [campo, operador, valor] = search.split(',').map((s) => s.trim())

                        // Validamos que el operador sea permitido
                        const validOperators = ['=', '!=', '>', '<', '>=', '<=']
                        if (!validOperators.includes(operador) && valor !== 'NULL') {
                            throw new Error('Operador no válido')
                        }

                        // query += ` WHERE ${campo} ${operador} ?`;
                        // params = [valor, pageSize, offset];
                        if (valor === 'NULL') {
                            if (operador === '=') {
                                query += ` WHERE ${campo} IS NULL`
                            } else if (operador === '!=') {
                                query += ` WHERE ${campo} IS NOT NULL`
                            } else {
                                throw new Error('Operador no válido para valores NULL')
                            }
                            params = [pageSize, offset] // No pasamos ? para NULL
                        } else {
                            query += ` WHERE ${campo} ${operador} ?`
                            params = [valor, pageSize, offset]
                        }
                    } catch (error) {
                        console.error('Error en el formato de búsqueda:', error)
                        reject('Formato de búsqueda inválido')
                        return
                    }
                }

                query += ` ORDER BY ROWID ASC LIMIT ? OFFSET ?;`

                console.log('query:', query, params)
                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            query,
                            params,
                            (_, result) => {
                                resolve(result.rows._array)
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }

    // getCountTableData = (tableName) => {
    //     return new Promise((resolve, reject) => {
    //         if (isWeb()) {
    //             reject('Not implemented for web')
    //         } else {
    //             db.transaction(
    //                 (tx) => {
    //                     tx.executeSql(
    //                         `SELECT COUNT(*) as count FROM ${tableName};`,
    //                         [],
    //                         (_, result) => {
    //                             resolve(result.rows.item(0).count) // Devuelve el conteo
    //                         },
    //                         (_, error) => {
    //                             reject(error)
    //                         },
    //                     )
    //                 },
    //                 (error) => {
    //                     console.error('SQLite transaction error:', error)
    //                     reject(error)
    //                 },
    //                 null,
    //             )
    //         }
    //     })
    // }
    getCountTableData = (tableName, search = '') => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                reject('Not implemented for web')
            } else {
                let query = `SELECT COUNT(*) as count FROM ${tableName}`
                let params = []

                // Si hay búsqueda, construimos la condición WHERE
                if (search) {
                    try {
                        const [campo, operador, valor] = search.split(',').map((s) => s.trim())

                        // Validamos que el operador sea permitido
                        const validOperators = ['=', '!=', '>', '<', '>=', '<=']
                        if (!validOperators.includes(operador) && valor !== 'NULL') {
                            throw new Error('Operador no válido')
                        }

                        if (valor === 'NULL') {
                            if (operador === '=') {
                                query += ` WHERE ${campo} IS NULL`
                            } else if (operador === '!=') {
                                query += ` WHERE ${campo} IS NOT NULL`
                            } else {
                                throw new Error('Operador no válido para valores NULL')
                            }
                        } else {
                            query += ` WHERE ${campo} ${operador} ?`
                            params = [valor]
                        }
                    } catch (error) {
                        console.error('Error en el formato de búsqueda:', error)
                        reject('Formato de búsqueda inválido')
                        return
                    }
                }

                db.transaction(
                    (tx) => {
                        tx.executeSql(
                            query,
                            params,
                            (_, result) => {
                                resolve(result.rows.item(0).count)
                            },
                            (_, error) => {
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite transaction error:', error)
                        reject(error)
                    },
                    null,
                )
            }
        })
    }

    get_pendings_conections = () => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                resolve({ status: 1, results: {} })
                return
            }

            try {
                // Usar el wrapper sync directamente para obtener conteos de forma robusta
                const dbSync = getWrappedDB()
                const tables = [
                    { name: SCHEDULES_STORE_NAMES.CHECKOUT, statusField: 'status', status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION },
                    { name: SCHEDULES_STORE_NAMES.CHECKIN, statusField: 'status', status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION },
                    {
                        name: SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS,
                        statusField: 'status_send',
                        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    },
                    { name: LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS, statusField: null },
                    { name: LEARNING_STORE_NAMES.ANSWERS_SURVEY, statusField: null },
                    {
                        name: SCHEDULES_STORE_NAMES.SCHEDULES_POS,
                        statusField: 'campaign_status',
                        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    },
                    { name: SCHEDULES_STORE_NAMES.UPLOAD_IMAGES_PENDING, statusField: null },
                    { name: SCHEDULES_STORE_NAMES.STORES_PENDING_SEND, statusField: null },
                    {
                        name: SCHEDULES_STORE_NAMES.FORMS_PENDING_SYNC,
                        statusField: 'status_send',
                        status_pending: STATUS_FORM_PENDING_SYNC.NO_SENDED,
                    },
                    { name: SCHEDULES_STORE_NAMES.SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS, statusField: null },
                ]

                const results = {}
                for (const table of tables) {
                    try {
                        let stmt
                        if (table.statusField) {
                            stmt = dbSync.prepareSync(`SELECT COUNT(*) as count FROM ${table.name} WHERE ${table.statusField} = ?`)
                            const row = stmt.getFirstSync([table.status_pending]) || { count: 0 }
                            results[table.name] = Number(row?.count) || 0
                            stmt.finalizeSync()
                        } else {
                            stmt = dbSync.prepareSync(`SELECT COUNT(*) as count FROM ${table.name}`)
                            const row = stmt.getFirstSync([]) || { count: 0 }
                            results[table.name] = Number(row?.count) || 0
                            stmt.finalizeSync()
                        }
                    } catch (err) {
                        console.error(`Error en la tabla ${table.name}:`, err)
                        results[table.name] = 0
                    }
                }

                const hasPending = Object.values(results).some((value) => typeof value === 'number' && value > 0)
                const generalStatus = hasPending ? 0 : 1
                resolve({ status: generalStatus, results })
            } catch (error) {
                console.error('get_pendings_conections failed:', error)
                reject(error)
            }
        })
    }

    updateLoginStatus = (isLoggedIn) => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                const transaction = db.transaction([USER_PROFILE], 'readwrite')
                const objectStore = transaction.objectStore(USER_PROFILE)

                const request = objectStore.getAll()

                request.onsuccess = (event) => {
                    const users = event.target.result

                    if (users && users.length > 0) {
                        const user = users[0]
                        user.login = isLoggedIn

                        const updateRequest = objectStore.put(user)

                        updateRequest.onsuccess = () => {
                            resolve({ success: true, user })
                        }

                        updateRequest.onerror = (event) => {
                            reject({ success: false, error: event.target.error })
                        }
                    } else {
                        resolve({ success: false, message: 'Usuario no encontrado' })
                    }
                }

                request.onerror = (event) => {
                    reject({ success: false, error: event.target.error })
                }
            } else {
                db.transaction(
                    (tx) => {
                        const selectQuery = `SELECT * FROM ${USER_PROFILE} LIMIT 1;`
                        tx.executeSql(
                            selectQuery,
                            [],
                            (_, selectResult) => {
                                const user = selectResult.rows.item(0)

                                if (user) {
                                    const updateQuery = `UPDATE ${USER_PROFILE} SET login = ?;`
                                    tx.executeSql(
                                        updateQuery,
                                        [isLoggedIn ? 1 : 0],
                                        () => {
                                            resolve({ success: true, user: { ...user, login: isLoggedIn } })
                                        },
                                        (_, error) => {
                                            reject({ success: false, error })
                                        },
                                    )
                                } else {
                                    resolve({ success: false, message: 'Usuario no encontrado' })
                                }
                            },
                            (_, error) => {
                                if (error.message.includes('no such table')) {
                                    resolve({ success: false, message: 'Tabla no existe' })
                                } else {
                                    reject({ success: false, error })
                                }
                            },
                        )
                    },
                    (error) => {
                        console.error('SQLite Transaction error:', error)
                        reject({ success: false, error })
                    },
                )
            }
        })
    }

    deleteAllTablesContents = async () => {
        console.log('estoy en la funcion que borra las tablas login/logout ')
        return new Promise(async (resolve, reject) => {
            if (isWeb()) {
                const request = window.indexedDB.deleteDatabase(dbName)

                request.onsuccess = () => {
                    console.log('Base de datos local eliminada exitosamente')
                    resolve()
                }

                request.onerror = (event) => {
                    console.error('Error al eliminar la base de datos local:', event.target.error)
                    reject(event.target.error)
                }
            } else {
                // Para SQLite, elimina todas las tablas usando declaraciones DROP TABLE
                db.transaction(
                    (tx) => {
                        tx.executeSql(`DROP TABLE IF EXISTS ${postsStoreName};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${versionsStoreName};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${LEARNING_STORE_NAMES.CATEGORIES};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${LEARNING_STORE_NAMES.COURSES};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${LEARNING_STORE_NAMES.CONTENTS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${LEARNING_STORE_NAMES.EVALUATIONS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${PORTFOLIO_STORE_NAMES.CATEGORIES};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${PORTFOLIO_STORE_NAMES.PRODUCTS};`)
                        // tx.executeSql(`DROP TABLE IF EXISTS ${USER_PROFILE};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${REACTIONS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${BENEFITS_STORE_NAMES.BENEFIT_HISTORY};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${BENEFITS_STORE_NAMES.REDEEMS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${BENEFITS_STORE_NAMES.POINTS_AWARDED};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.STORES};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${POST_TABLE_NAMES.VIEWED_POSTS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.FORMS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.CAMPAINGS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULES};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${TRACKINGS.TRACKINGS};`)
                        // tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.CHECKIN};`)
                        // tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.CHECKOUT};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULES_POS};`)
                        // tx.executeSql(`DROP TABLE IF EXISTS ${FOOTER_APP};`)
                        // tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.CHECKIN_STEPS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.FORMS_ADDITIONALS};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.FORMS_PERFECT_STORE};`)
                        tx.executeSql(`DROP TABLE IF EXISTS ${SCHEDULES_STORE_NAMES.PERFECT_STORE_VERSION};`)
                    },
                    null,
                    () => {
                        console.log('Todas las tablas eliminadas exitosamente')
                        resolve()
                    },
                    (error) => {
                        console.log('🚀 ~ returnnewPromise ~ error:', error)
                        console.error('Error al eliminar las tablas:', error)
                        reject(error)
                    },
                )
            }
        })
    }

    getTableRecordCount = async (tableName) => {
        try {
            return new Promise((resolve, reject) => {
                db.transaction(
                    (tx) => {
                        const query = `SELECT COUNT(*) as count FROM ${tableName};`
                        tx.executeSql(
                            query,
                            [],
                            (_, result) => {
                                const count = result.rows.item(0).count || 0
                                resolve(count)
                            },
                            (_, error) => {
                                console.error(`Error al contar registros en la tabla ${tableName}:`, error)
                                reject(error)
                            },
                        )
                    },
                    (error) => {
                        console.error('Error en la transacción:', error)
                        reject(error)
                    },
                    null,
                )
            })
        } catch (error) {
            console.error('Error en getTableRecordCount:', error)
            throw error // Para manejo externo
        }
    }

    /**
     * 🆕 Obtiene el módulo del repositorio de usuario (con cache)
     * @returns {Promise<Object>}
     */
    getUserRepository = async () => {
        if (!__userRepositoryModule) {
            __userRepositoryModule = await import('../db-sqlite/repositories/user.repository')
        }
        return __userRepositoryModule
    }

    /**
     * 🆕 Guarda o actualiza un usuario usando el repositorio TypeScript
     * @param {Object} userData - Datos del usuario a guardar
     * @returns {Promise<void>}
     */
    upsertUser = async (userData) => {
        console.log('🔄 upsertUser (wrapper) =>', userData?.name)
        
        try {
            // ✅ Usar el módulo cacheado del repositorio
            const userRepository = await this.getUserRepository()
            await userRepository.upsertUser(userData)
            console.log('✅ Usuario guardado/actualizado correctamente')
        } catch (error) {
            console.error('❌ Error en upsertUser:', error)
            throw error
        }
    }

    /**
     * 🆕 Obtiene el usuario actual (primer usuario en la BD)
     * @returns {Promise<Object|null>}
     */
    getUserFromRepo = async () => {
        console.log('🔍 getUserFromRepo (wrapper)')
        
        try {
            const userRepository = await this.getUserRepository()
            const user = await userRepository.getUser()
            console.log('✅ Usuario obtenido:', user?.name)
            return user
        } catch (error) {
            console.error('❌ Error en getUserFromRepo:', error)
            throw error
        }
    }

    /**
     * 🆕 Actualiza campos específicos del usuario
     * @param {string} userId - ID del usuario
     * @param {Object} fields - Campos a actualizar
     * @returns {Promise<void>}
     */
    updateUserFields = async (userId, fields) => {
        console.log('🔄 updateUserFields (wrapper) =>', userId, fields)
        
        try {
            const userRepository = await this.getUserRepository()
            await userRepository.updateUserFields(userId, fields)
            console.log('✅ Campos de usuario actualizados')
        } catch (error) {
            console.error('❌ Error en updateUserFields:', error)
            throw error
        }
    }
}

export const UserServices = new userServices(db)
